import $ from 'jquery';
import { tns } from 'tiny-slider/src/tiny-slider';
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
gsap.registerPlugin(DrawSVGPlugin);
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import {ionRangeSlider} from 'ion-rangeslider';
import SnazzyInfoWindow from 'snazzy-info-window/dist/snazzy-info-window.js';

window.jQuery = $;
require('@fancyapps/fancybox');
import barba from '@barba/core';
const forms = {
    class : '.form, .newsletter',
    forms : null,
    inputClass : '.form-field, .newsletter-field',
    inputs : null,
    errorClass : '.error',
    errors : null,
    checkboxClass : '.form-checkbox',
    checkboxes: null,
    init: function(container){
        let obj = this;
        obj.forms = $(container).find(obj.class);
        if(obj.forms.length > 0){
            $.each(obj.forms, function(){
                let $form = $(this);
                obj.errors = $form.find(obj.errorClass);
                obj.inputs = $form.find(obj.inputClass).find('input');
                obj.checkboxes = $form.find(obj.checkboxClass);

                $.each(obj.inputs, function(){
                    $(this).keyup(obj.updateInput);
                });

                $.each(obj.checkboxes, function(){
                    $(this).change(obj.updateCheckbox);
                });

                $form.submit(function(e){
                    e.preventDefault();
                    let $this = $(this);
                    let $bt = $this.find('button[type="submit"]');
                    if($bt.length){
                        $bt[0].disabled = true;
                    }

                    let $fields = $this.find('.form-field');
                    let $errorMsg = $this.find('.form-messages--error');
                    $errorMsg.fadeOut();
                    let $succesMsg = $this.find('.form-messages--success');
                    if(obj.errors.length > 0){
                        obj.errors.html('').parent().removeClass('has-error');
                    }
                    $.ajax({
                        url:$this.attr('action'),
                        data: $this.serialize(),
                        type: 'POST'
                    }).done(function( data ) {
                        if(data.status === 0){
                            $.each(data.errors, function(){
                                let error = this;
                                $('#error-'+error[1]).hide().html(error[0]).fadeIn().parent().addClass('has-error');
                            });
                            $errorMsg.fadeIn(function(){
                                $bt[0].disabled = false;
                            });
                        }else{
                            $fields.hide();
                            $errorMsg.hide();
                            $succesMsg.fadeIn();
                            a_events(6);
                        }
                    })
                });

                $(this).focusin(obj.updateInput);

            })
        }
    },
    updateCheckbox: function(event){
        let $this = $(this);
        $this.parent().removeClass('has-error').find('.error').fadeOut().html('');
    },
    updateInput : function(event){
        let $this = $(this);
        let $parent = $this.parent();
        let $grand = $parent.parent();

        if($grand.hasClass('has-error')){
            $grand.removeClass('has-error');
            $parent.next().html('');
        }

        if($this.val().length > 0){
            $parent.addClass('float');
        }else{
            $parent.removeClass('float');
        }
    },
    leave: function(){

        let obj = this;
        if(obj.inputs !== null){
            $.each(obj.inputs, function(){$(this).off();});
            obj.inputs = null
        }
        if(obj.forms !== null){
            $.each(obj.forms, function(){$(this).off();});
            obj.forms = null
        }
        if(obj.errors !== null){
            $.each(obj.errors, function(){$(this).off();});
            obj.errors = null
        }
        if(obj.checkboxes !== null){
            $.each(obj.checkboxes, function(){$(this).off();});
            obj.checkboxes = null
        }
    }
};
const scrollTo = {
    class : '.scroll-to',
    offset : $('.header-inner').outerHeight(),
    init : function(){
        let obj = this;
        $(document).on('click', obj.class, function(e){
            e.preventDefault();
            let $this = $(this);
            let target = $this.data('target');
            let $target = $(target);
            $(menu.menuClass).removeClass('is-open');
            if($target.length){
                gsap.to(window, {scrollTo: ($target.offset().top - obj.offset)});
            }else{
                let $hash = $this.attr('href');
                if(typeof barba !== 'undefined'){

                }
                console.log($hash);
            }
        })
    }
};
const header = {
    headerClass : '.header',
    $header : null,
    init : function(){
        let obj = this;
        obj.$header = $(obj.headerClass);
        if(obj.$header.length > 0){
            console.log('Init header');
            obj.check(obj.$header);
            $(document).scroll(function(){
                obj.check(obj.$header);
            })
        }

    },
    check: function(header){
        if($(document).scrollTop() > 2){
            header.addClass('header-sticky')
        }else{
            header.removeClass('header-sticky')
        }
    },
    toggleClass: function(namespace){
        let obj = this;
        if(obj.$header !== null){
            switch(namespace){
                case('apartments'):
                    obj.$header.addClass('header-white');
                    break;
                case('offer_no-dark'):
                    obj.$header.addClass('header-white');
                    break;
                case('offer_black'):
                    obj.$header.removeClass('header-white');
                    break;
                default:
                    obj.$header.removeClass('header-white');
                    break;
            }
        }
    }

};
const menu = {
    btClass : '.toggle-menu',
    menuClass : '.menu-main',
    init: function(){
       let obj = this;
       let $bt = $(obj.btClass);
       let $menu = $(obj.menuClass);
       if($bt.length > 0 && $menu.length > 0){
           $bt.on("click", function(e){
               e.preventDefault();
               console.log('clicked');
               $menu.toggleClass('is-open');
           })
       }
    }
};
const house = {
    houseClass : '.house-svg',
    floorClass : '.house-svg--floor path',
    $house : null,
    $floors : null,
    tooltipClass : '.tooltip',
    $tooltip: null,
    tl : null,
    tl2 :  null,
    init : function(container){
        let obj = this;
        obj.$house = $(container).find(obj.houseClass);
        obj.$floors = $(container).find(obj.floorClass);
        obj.$tooltip = $(obj.tooltipClass);
        let timeout = null;
        if(obj.$floors.length) {
            obj.reveal(obj.$floors);
        }

        if(obj.$tooltip.length) {
            obj.$floors.mouseenter(function(e) {
                clearTimeout(timeout);
                let $this = $(this);
                let point = $this.next().position();
                let floor = $this.parent().data('floor');
                let $nr = obj.$tooltip.find('.tooltip-floor');
                let $av = obj.$tooltip.find('.tooltip-available');

                $nr.html(floor);
                $av.html(floorStats[floor]);


                if(!obj.$tooltip.hasClass('animating')){
                    obj.$tooltip.css({
                        left: point.left - obj.$tooltip.width()/2 ,
                        top: point.top - obj.$tooltip.height()/2,
                    });
                    obj.$tooltip.addClass('animating').addClass('is-active');
                }else{
                    gsap.to(obj.$tooltip, 0.5, {
                        force3D: true,
                        left: point.left - obj.$tooltip.width()/2,
                        top: point.top - obj.$tooltip.height()/2
                    })
                }
            }).mouseleave(function(e){
                timeout = setTimeout(function(){
                    obj.$tooltip.removeClass('animating').removeClass('is-active');
                });
            })
        }

    },
    reveal : function($floors){

        let obj = this;

        obj.tl2 = gsap.timeline({paused:true, ease: "circ.inOut",  onComplete: function(){
            obj.tl.kill();
            obj.tl2.kill();
            obj.tl = null;
            obj.tl2 = null;
        }});

        obj.tl = gsap.timeline({paused:true,  ease: "circ.inOut" , onComplete: function(){
            $.each($floors, function(i){
                if(i === 0){
                    obj.tl2.to(this, {fillOpacity: 0, clearProps:"all", delay:0.2, duration: 0.5}, );
                }else{
                    obj.tl2.to(this, {fillOpacity: 0, clearProps:"all", duration: 0.5}, '-=0.35');
                }
            });
            obj.tl2.play();
        }});

        $.each($floors, function(i){
            if(i === 0) {
                obj.tl.to(this, {fillOpacity: 0.7, duration: 0.5, delay:0.8});
            }else{
                obj.tl.to(this, {fillOpacity: 0.7, duration: 0.5}, '-=0.35');
            }
        });

        obj.tl.play();

    }
};

const floor = {
    offset : '.ap-floor',
    $offset : null,
    apartClass : '.floor-svg a, .floor-svg .floors-parking',
    $apart : '',
    navClass : '.floor-change',
    $nav : null,
    planClass: '.ap-floor-plans',
    tooltipClass: '.tooltip',
    parkingClass: '.floors-parking',
    $parking : '',
    init: function(container){
        let obj = this;

        obj.$nav = $(container).find(obj.navClass);
        obj.$tooltip = $(container).find(obj.tooltipClass);
        obj.$offset = $(container).find(obj.offset).offset();


        obj.$aparts = $(container).find(obj.apartClass);
        obj.$parking = $(container).find(obj.parkingClass);

        $.each(obj.$aparts, function(){
            if($(this).hasClass('Sold')){
                $(this).attr('href', '').removeClass('barba-link').click(function(e){ e.preventDefault();return false;});
            }
        });

        obj.$nav.click(function(e){
            e.preventDefault();
            obj.$nav.removeClass('active');
            let $this = $(this);
            $this.addClass('active');
            let floor = $this.data('floor');
            $(container).find(obj.planClass).removeClass('active');
            $(container).find('.ap-floor-'+floor).addClass('active');
            obj.$tooltip.removeClass('animating').removeClass('is-active');
            let url = window.location.href;
            url = url.split('?');
            if(typeof url[1] !== 'undefined'){
                url = $this.attr('href')+'?'+url[1]
            }else{
                url = $this.attr('href');
            }
            window.history.replaceState('', '',url);
            window.history.pushState('forward', 'Aukštas '+floor,url);
        });

        let clear ;
        $(obj.$aparts).mouseenter(function(e){

            let $this = $(this);
            clearTimeout(clear);
            let id = $this.data('id');
            let point = $this.find('.apart-dot').position();
            let $rooms = obj.$tooltip.find('.tooltip-rooms span');
            let $area = obj.$tooltip.find('.tooltip-area span');
            let $nr = obj.$tooltip.find('.tooltip-nr');
            let $price = obj.$tooltip.find('.tooltip-price span');
            let $status = obj.$tooltip.find('.tooltip-status');
            let data = [];
            if(!$this.hasClass('floors-parking')) {
                data = floorData[id - 1];
                $rooms.html(data['rooms']).parent().show();
                $area.html(data['area']).parent().show();
                obj.$tooltip.removeClass('tooltip-garage');
            }else{
                obj.$tooltip.addClass('tooltip-garage');
                data = parkingData[id - 1];
                $area.parent().hide();
                $rooms.parent().hide();

                if(roughScale(data['price']) === 0){
                    obj.$tooltip.addClass('no-price');
                }
            }

            $nr.html(data['nr']);


            if(typeof data['disc'] !== 'undefined' && data['disc'].length > 1){
                $price.html(data['disc']).parent().addClass('price-discounted').show();
            }else{
                $price.html(data['price']).parent().removeClass('price-discounted').show();
            }

            if(typeof data['disc'] === 'undefined' && typeof data['price'] === 'undefined'){
                $price.parent().hide();
            }
            if(roughScale(data['price']) === 0){
                $price.parent().hide();
            }
            function roughScale(x) {
                const parsed = parseInt(x);
                if (isNaN(parsed)) { return 0; }
                return parsed * 100;
            }

            let status = '';
            switch(data['status']){
                case('Available'):
                    status = 'LAISVAS';
                    break;
                case('Sold'):
                    status = 'PARDUOTAS';
                    break;
                case('Reserved'):
                    status = 'REZERVUOTAS';
                    break;
            }
            $status.html(status);

            let $yes = 0;
            console.log(data['floor1']);
            if(data['floor1'] === 'yes'){
                $yes++;
            }
            if(data['floor2'] === 'yes'){
                $yes++
            }
            if(data['floor3'] === 'yes'){
                $yes++
            }
            if(data['floor4'] === 'yes'){
                $yes++
            }
            console.log($yes);

            if($yes > 1){
                obj.$tooltip.find('.tooltip-notice span').html($yes);
                obj.$tooltip.addClass('multiple-floors')
            }else{
                obj.$tooltip.removeClass('multiple-floors');
            }

            obj.$tooltip
                .removeClass('Available')
                .removeClass('Reserved')
                .removeClass('Sold')
                .addClass(data['status']);

            obj.$tooltip.removeClass('multiple-floors');

            if(data['status'] !== 'Sold') {
                if ($yes > 1) {
                    obj.$tooltip.find('.tooltip-notice span').html($yes);
                    obj.$tooltip.addClass('multiple-floors')
                }
            }
            
            let fix = 0;

            if((point.left + obj.$tooltip.width()) > $(document).width()){
                fix = obj.$tooltip.width();
            }

            if(!obj.$tooltip.hasClass('animating')){
                obj.$tooltip.css({
                    left: point.left - fix - $(container).find(obj.offset).offset().left,
                    top: point.top - obj.$tooltip.height() -  $(container).find(obj.offset).offset().top,
                });
                obj.$tooltip.addClass('animating').addClass('is-active');
            }else{
                gsap.to(obj.$tooltip, 0.5, {
                    force3D: true,
                    left: point.left - fix -  $(container).find(obj.offset).offset().left,
                    top: point.top - obj.$tooltip.height() -  $(container).find(obj.offset).offset().top
                });
                obj.$tooltip.addClass('is-active');
            }
        }).mouseleave(function(e){
            clear = setTimeout(function(){
                obj.$tooltip.removeClass('is-active');
            },400);

        });
/*

        obj.$parking = $(container).find(obj.parkingClass);

        obj.$parking.mouseenter(function(e){
            let $this = $(this);
            clearTimeout(clear);
            let id = $this.data('id');

            let point = $this.find('.apart-dot').position();
            let data = parkingData[id-1];

            console.log()


        })
*/


    }



};


const filter = {
    filterClass : '.filter-form',
    $filter : null,
    sliderClass : '.slider',
    sliders : [],
    $checkboxes : null,
    tableClass : '.filter-list',
    $table : null,
    $spinner : null,
    spinnerClass : '.filter-loader',
    resetClass : '.filter-notice > [type="reset"]',
    $reset : null,
    init: function(container){
        let obj = this;

        obj.$filter = $(container).find(obj.filterClass);
        obj.slider(container);

        if(obj.$filter !== null){

            obj.$reset = $(container).find(obj.resetClass);
            obj.$spinner = $(container).find(obj.spinnerClass);
            if(obj.$spinner.length ){
                gsap.to(obj.$spinner.find('svg'), {
                    rotation: 360,
                    duration: 1,
                    repeat: -1,
                    ease: "linear"}
                    )
            }

            obj.$checkboxes = obj.$filter.find('[type="checkbox"]');
            obj.$table = $(container).find(obj.tableClass);
            obj.$filter.submit(function(e) {
                e.preventDefault();
                let $this = $(this);
                $.ajax({
                    data: $this.serialize(),
                    type: 'post',
                    url: $this.attr('action'),
                    beforeSend: function () {
                        if(obj.$spinner.length){
                            obj.$spinner.fadeIn();
                        }
                    },
                    success: function (data) {
                    },
                    complete: function (data) {
                    }
                }).done(function (data) {
                    data = JSON.parse(data);

                    obj.$table.html('');
                    if(data.status === 1){
                        obj.$table.html(data.html);
                        sanim.listdeinit();
                        sanim.listinit(obj.$table);
                        $(container).find('.filter-notice').fadeOut();
                        ScrollTrigger.refresh();
                    }else{
                        $(container).find('.filter-notice').fadeIn();
                    }

                    let url = window.location.href;
                    url = url.split('?');
                    window.history.replaceState('', '', url[0]+'?'+data.url);
                    setTimeout(function(){
                        obj.$spinner.fadeOut();
                    },800)
                })
            });

            obj.$reset.click(function(e){
                e.preventDefault();
                obj.sliders.data("ionRangeSlider").reset();
                obj.sliders.data("ionRangeSlider").update({
                    from: obj.sliders.data("ionRangeSlider").options.min,
                    to: obj.sliders.data("ionRangeSlider").options.max
                });
               // obj.$filter.find('[type=checkbox]').prop('checked', false);
                obj.$filter.find('[type=checkbox]').removeAttr('checked');
                obj.$filter[0].reset();

                obj.$filter.submit();

            });

            obj.$checkboxes.on('change', function(e){
                obj.$filter.submit();
            })
        }

    },
    slider: function(container){
        let obj = this;
        obj.sliders = $(container).find(obj.sliderClass).ionRangeSlider({
            type: "double",
            skin: 'custom',
            grid: false,
            postfix: " €",
            onChange: function (data) {
                console.log(data)
            },
            onFinish: function () {
                obj.$filter.submit();
            },
        });
    },
    leave: function(){
        let obj = this;
        $.each(obj.$filter, function(){
            $(this).off();
        });
        obj.$filter = null;

        if(obj.sliders.length) {
            obj.sliders.data("ionRangeSlider").destroy();
        }

        if(obj.$filter !== null) {
            obj.$filter.off();
            obj.filter = null;
            obj.$table = null;
            obj.$checkboxes.off();
            obj.$checkboxes = null;
            gsap.killTweensOf(obj.$spinner.find('svg'));
        }

    }
};
const apartment = {
    planClass : '.apartment-plan',
    floorClass : '.ap-apartment--floors a',
    typeClass : '.plan-toggle',
    floor: 1,
    type: '3d',
    plans: null,
    compass: null,
    init: function(container){
        console.log('init apartment');
        let obj = this;

        let $floors = $(container).find(obj.floorClass);
        let $types = $(container).find(obj.typeClass);
        obj.plans = $(container).find(obj.planClass);

        obj.floor = $floors.first().data('floor');
        obj.type = $types.last().data('type');

        obj.compass = $(container).find('.ap-apartment--compass');

        if(typeof obj.type === 'undefined'){
            obj.type = '2d';
        }
        obj.plans.first().addClass('active');

        $floors.click(function(e){
            e.preventDefault();
            let $this = $(this);
            if($this.hasClass('active')){
                return false;
            }
            $floors.removeClass('active');
            $this.addClass('active');
            obj.floor = $this.data('floor');

            obj.changePlan();
        });


        $types.click(function(e){
            e.preventDefault();
            let $this = $(this);
            if($this.hasClass('active')){
                return false;
            }

            $types.removeClass('active');
            $this.addClass('active');
            obj.type = $this.data('type');
            obj.changePlan();
        });


        $('[data-fancybox="show_floor"]').fancybox({
            afterShow : function( instance, current ) {
                $('.current-floor--close').click(function(e){
                    e.preventDefault();
                    instance.close();
                })
            }

        });
    },
    changePlan: function(){
        let obj = this;
        console.log(obj.floor);
        console.log(obj.type);

        if(obj.type === '2d'){
            obj.compass.removeClass('ap-apartment--compassHidden')
        }
        if(obj.type === '3d'){
            obj.compass.addClass('ap-apartment--compassHidden');
        }
        obj.plans.removeClass('active');
        $.each(obj.plans, function(){
            if($(this).hasClass('apartment-'+obj.floor+'-'+obj.type)){
                $(this).addClass('active');
            }
        })
    }
};



/*var svgt_time = 1.5; // svg title animation speed in seconds

var svgt_list = $(".title-container");

svgt_list.each(function (index, element) {
    var $this = $(this);

    var svg = $this.find(".svgt-title");
    var dend = svg.data("dend");
    if(typeof dend == "undefined") return true;

    var msk = svg.find("clipPath path");
    var linel = svg.find(".svgt-line-l");
    var liner = svg.find(".svgt-line-r");
    var svgd = svg.get(0).viewBox.baseVal;
    var move = ((svgd.height * 0.644) + svgd.width) * 0.5;

    var tl = gsap.timeline({
        paused:true,
        scrollTrigger: {
            trigger: $this,
            start: "top 60%",
            end: "bottom bottom"
        }
    });

    tl.to(msk, {duration: svgt_time, attr: {d:dend}, ease:"power1.out"})
        .to(linel, {duration: svgt_time, x:-move, ease:"power1.out"}, 0)
        .to(linel, {duration: svgt_time * 0.5, opacity:0, ease:"power1.out"}, 0)
        .to(liner, {duration: svgt_time, x:move, ease:"power1.out"}, 0)
        .to(liner, {duration: svgt_time * 0.5, opacity:0, ease:"power1.out"}, 0);
});*/

const title = {
    titles : [],
    init: function(container){
        let obj = this;
        console.log('init titles')

        var svgt_time = 1.5; // svg title animation speed in seconds

        var svgt_list = $(container).find(".title-container");

        svgt_list.each(function (index, element) {
            var $this = $(this);

            var svg = $this.find(".svgt-title");
            var dend = svg.data("dend");
            if(typeof dend == "undefined") return true;

            var dl = $this.data("delay");
            if(typeof dl == "undefined") dl = 0;
            if(typeof dl == "string") dl = parseInt(dl);

            var msk = svg.find("clipPath path");
            var linel = svg.find(".svgt-line-l");
            var liner = svg.find(".svgt-line-r");
            var svgd = svg.get(0).viewBox.baseVal;
            var move = ((svgd.height * 0.644) + svgd.width) * 0.5;

            var tl = gsap.timeline({
                paused:true,
                scrollTrigger: {
                    trigger: $this,
                    start: "top 80%",
                    end: "bottom bottom",
                    onEnter: function(){
                        setTimeout(function(){
                            $this.find(".decoLine-inner").addClass("deco-done");
                        }, dl*1000);
                    }
                },
                delay: dl
            });

            tl.to(msk, {duration: svgt_time, attr: {d:dend}, ease:"power1.out"})
                .to(linel, {duration: svgt_time, x:-move, ease:"power1.out"}, 0)
                .to(linel, {duration: svgt_time * 0.5, opacity:0, ease:"power1.out"}, 0)
                .to(liner, {duration: svgt_time, x:move, ease:"power1.out"}, 0)
                .to(liner, {duration: svgt_time * 0.5, opacity:0, ease:"power1.out"}, 0);


            obj.titles.push(tl);
        });
    },
    destroy : function(){
        $.each(this.titles, function(){
            this.kill();
        });

        title.titles = [];
    }
};
const sanim = {
    st: [],
    tweens: [],
    list: [],
    
    init: function(cnt){
        console.log("init scroll animations");
        let o = this;
        let dom = $(cnt);

        let moon = dom.find(".fp-priv--logo");
        if(moon.length > 0){
            let mtl = gsap.timeline({
                scrollTrigger: {
                    trigger: moon.parent(),
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });
            mtl.fromTo(moon, {y: "-50%"}, {duration:1, y: "50%", ease:"none"});
            o.tweens.push(mtl);
        }

        let lists = dom.find(".fp-priv--list, .fp-map--locs");
        if(lists.length > 0){
            lists.each(function (index, element) {
                // element == this
                let $this = $(this);
                let rows = $this.find(".fp-priv--listRow, .fp-map--list");
                if(rows.length > 0){
                    let ltl = gsap.timeline({
                        scrollTrigger: {
                            trigger: $this,
                            start: "top 90%",
                            end: "bottom bottom"
                        }
                    });
                    ltl.fromTo(rows, {x: gsap.utils.wrap([-30, 30]), opacity:0}, {duration:2, x:0, opacity:1, ease:"power4.out"});
                    o.tweens.push(ltl);
                }
            });
        }

        let sanims = dom.find(".sanim:not(.sanim-done)");
        if(sanims.length > 0){
            sanims.each(function (index, element) {
                // element == this
                let $this = $(this);
                let trigger = $this.data("trigger");
                if(typeof trigger == "undefined") trigger = "90";
                let stanim = ScrollTrigger.create({
                    trigger: $this,
                    start: `top ${trigger}%`,
                    end: "bottom bottom",
                    onEnter: function(){
                        $this.addClass("sanim-done");
                    }
                });

                o.st.push(stanim);
            });
        }

        let header = $(".header-waiting");
        header.each(function (index, element) {
            // element == this
            var $this = $(this);
            //gsap.fromTo(this, {y: -30, opacity:0}, {duration:2, y:0, opacity:1, ease:"power4.out", clearProps:"all", delay: index * 0.2 + 0.2});
            setTimeout(function(){
                $this.removeClass("header-waiting");
            }, (index * 0.15 + 0.2) * 1000);
        });
    },

    deinit: function(){
        console.log("de-init scroll animations");
        let o = this;

        $.each(o.tweens, function(){
            this.kill();
        });
        o.tweens = [];

        $.each(o.st, function(){
            this.kill();
        });
        o.st = [];
    },

    listinit: function(cnt){
        console.log("init lists");
        let o = this;
        let dom = $(cnt);
        let listanim = dom.find(".listanim:not(.sanim-done)");
        if(listanim.length > 0){
            listanim.each(function (index, element) {
                // element == this
                let $this = $(this);
                let trigger = $this.data("trigger");
                if(typeof trigger == "undefined") trigger = "90";
                let stanim = ScrollTrigger.create({
                    trigger: $this,
                    start: `top ${trigger}%`,
                    end: "bottom bottom",
                    onEnter: function(){
                        $this.addClass("sanim-done");
                    }
                });

                o.list.push(stanim);
            });
        }
    },

    listdeinit: function(){
        let o = this;
        console.log("de-init lists");
        $.each(o.list, function(){
            this.kill();
        });
        o.list = [];
    }
};

"use strict";
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function(){
    header.init();
    scrollTo.init();
    menu.init();


    barba.init({
        debug: true,
        logLevel: 2,
        prevent: ({ el }) => !el.classList.contains('barba-link'),
        transitions: [{
            name: 'default',
            once(){
                //console.log('WTF');
            },
            leave(d) {
                return gsap.to(d.current.container, {
                    opacity: 0
                });
            },
            after(d) {
                return gsap.from(d.next.container, {
                    opacity: 0
                });
            }
        }],
        views: [
            {
                namespace: 'home',
                beforeEnter() {
                    // update the menu based on user navigation
                    header.toggleClass('home');
                },
                afterEnter(data) {
                    let $vd = $(data.next.container).find('video');
                    if($vd.length){
                        $vd[0].play();
                    }
                },
                beforeLeave(){

                }
            },
            {
                namespace: 'apartments',

                once(data){

                },
                beforeEnter(data) {
                    // update the menu based on user navigation
                    header.toggleClass('apartments');
                    house.init(data.next.container);
                    filter.init(data.next.container);
                },
                afterEnter(data) {
                    // refresh the parallax based on new page content
                    filter.init(data.next.container);
                    house.init(data.next.container);
                    extra_popup(data.next.container);
                },
                afterLeave(){
                    filter.leave();
                }
            }
            ,
            {
                namespace: 'floor',
                once(data){

                },
                beforeEnter(data) {
                    // update the menu based on user navigation
                    header.toggleClass('floor');
                    filter.init(data.next.container);


                },
                afterEnter(data) {
                    floor.init(data.next.container);
                    // refresh the parallax based on new page content
                },
                Enter(data){

                },
                after(){
                    console.log('after :')

                },
                afterLeave(){
                    filter.leave();
                }
            },
            {
                namespace: 'apartment',
                once(data){

                },
                beforeEnter(data) {
                    // update the menu based on user navigation
                    header.toggleClass('floor');
                    filter.init(data.next.container);
                },
                afterEnter(data) {
                    apartment.init(data.next.container);

                    // refresh the parallax based on new page content
                },
                Enter(data){
                    console.log('enter :');
                },
                after(){
                    console.log('after :')

                },
                afterLeave(){
                    filter.leave();
                }
            }
            , {
                namespace: 'offer',
                once(data){

                },
                beforeEnter(data) {
                    // update the menu based on user navigation
                    header.toggleClass('offer');

                    console.log($(data.next.container).find('.image .desktop'));
                    if($(window).width() > 900){

                        if($(data.next.container).find('.image .desktop').hasClass('no-dark')){
                            header.toggleClass('offer_no-dark');
                        }else{
                            header.toggleClass('offer');
                        }
                    }else{
                        $(data.next.container).find('.image .mobile');
                        if($(data.next.container).find('.image .mobile').hasClass('no-dark')){
                            header.toggleClass('offer_no-dark');
                        }else{
                            header.toggleClass('offer');
                        }
                    }

                  //  filter.init(data.next.container);
                },
                afterEnter(data) {
                  //  apartment.init(data.next.container);

                    // refresh the parallax based on new page content
                },
                Enter(data){
                    console.log('enter :');
                },
                after(){
                    console.log('after :')

                },
                afterLeave(){
                  //  filter.leave();
                }
            }
        ]
    });


    function extra_popup(container){

        var projectslistpopup = $(container).find('.projects-list-popup');

        if(projectslistpopup.length) {
            var projectslistpopuptimer = setInterval(function () {
                projectslistpopup.addClass('active');
                $(document).off('mouseleave.popupproject');
            }, popup_show_time);
        }

        projectslistpopup.find('.close-popup').click(function(e){
            e.preventDefault();
            $(this).parent().removeClass('active');
            clearInterval(projectslistpopuptimer);
        });
    }


    barba.hooks.once((data) => {
        forms.init(data.next.container);
        title.init(data.next.container);
        sanim.init(data.next.container);
        sanim.listinit(data.next.container);
    });

    barba.hooks.before((data) => {

        forms.leave();
        $(menu.menuClass).removeClass('is-open');
    });


    barba.hooks.enter((data) => {
        window.scrollTo(0, 0);

        title.init(data.next.container);
        sanim.init(data.next.container);
        sanim.listinit(data.next.container);

        let $trigger = $(data.trigger);
        if($trigger.hasClass('scroll-to')){
            let target = $trigger.data('target');
            let $target = $(target);
            if($target.length) {
                setTimeout(function(e){
                    gsap.to(window, {scrollTo: ( $(target).offset().top - scrollTo.offset)});
                })
            }
        }
    });

    barba.hooks.after((data) => {
        forms.init(data.next.container);
        ScrollTrigger.refresh();
    });

    barba.hooks.leave((data) => {
        title.destroy();
        sanim.deinit();
        sanim.listdeinit();
    });


    function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let $cf = $('#footer-cookie');
    let cfa = 'footer-cookie--active';

    if(getCookie('cookie-policy') == '1'){
        $cf.removeClass(cfa);
    } else {
        $cf.addClass(cfa);
    }

    $('.cookie-accept').click(function(e){
        e.preventDefault();
        setCookie('cookie-policy', '1', 365);
        $cf.removeClass(cfa);
    });

    if(typeof popuptime !== 'undefined') {

        var offerspopupShow = 1;

        var offerspopuptimer = setTimeout(function () {
                $.fancybox.open({
                    src: '#popup-offers',
                    type: 'inline',
                    baseClass: 'popup',
                    touch: false,
                    afterShow: function (instance) {
                       //instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                        forms.init(instance.current.$content);
                        document.cookie = "popup-offers=1;expires=0;path=/";
                        offerspopupShow = 0;
                        sanim.deinit();
                        sanim.listdeinit();
                        sanim.init(document);
                        sanim.listinit(document);

                    }
                });
            }, popuptime
        );

        if (showLeave == 1) {

            $(document).mouseleave(function() {
                if ($('.fancybox-container.popup').length == 0 && offerspopupShow) {
                    $.fancybox.open({
                        src: '#popup-offers',
                        type: 'inline',
                        baseClass: 'popup',
                        touch: false,
                        afterShow: function (instance) {
                            //  instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                            forms.init(instance.current.$content);
                            document.cookie = "popup-offers=1;expires=0;path=/";
                            offerspopupShow = 0;
                            sanim.deinit();
                            sanim.listdeinit();
                            sanim.init(document);
                            sanim.listinit(document);
                        }
                    });
                    clearInterval(offerspopuptimer);
                }
            });
        }
    }






});

window.a_events = function(id, type){
    if(typeof gtag !== 'undefined'){

        switch(id){
            case(1):
                gtag('event','paspaudimas', {
                    'event_category': 'mygtukas',
                    'event_label': 'BUTAI tituliniame',
                });
                break;
            case(2):
                gtag('event','paspaudimas', {
                    'event_category': 'mygtukas',
                    'event_label': type+' meniu',
                });
                break;
            case(3):
                gtag('event','paspaudimas', {
                    'event_category': 'instagram',
                    'event_label': 'Instagram profilis',
                });
                break;

            case(4):
                gtag('event','paspaudimas', {
                    'event_category': 'telefonas',
                    'event_label': 'Pardavėjo tel. nr. Justinas',
                });
                break;
            case(5):
                gtag('event','paspaudimas', {
                    'event_category': 'email',
                    'event_label': 'Pardavėjo el. paštas Justinas',
                });
                break;

            case(6):
                gtag('event','išsiuntimas', {
                    'event_category': 'forma',
                    'event_label': 'Sėkmingai užpildyta forma'
                });

                break;
        }
    }
};

